// src/features/dashboard/selectors.js
import { createSelector } from "@reduxjs/toolkit";

export const selectAgentMapByBU = createSelector(
  (state) => state.dashboard.agentMap,
  (agentMap) => {
    if (!agentMap) return null;

    return Object.fromEntries(
      Object.entries(agentMap).map(([buKey, agents]) => [
        buKey,
        Object.fromEntries(
          agents.map((agentName) => [
            agentName,
            { display: agentName, subagents: [] },
          ])
        ),
      ])
    );
  }
);

export const selectBUOptions = createSelector(
  (state) => state.dashboard.agentMap,
   (agentMap) => (agentMap ? Object.keys(agentMap) : [])
);